// Author Shi Wen Long
// Date 2022-04-26 16:31:56

import * as model from "@/model/sithMes/stool/SithMesStool26StockTransferModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStool26StockTransfer(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
        callbackApi: process.env.VUE_APP_SITHMES_STOOL_URL + '/sithMesStool26StockTransfer/workflow/complete-feedback',
        processDefinitionKey: "stool_26_stock_transfer",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
